import React from 'react';
import { Icon } from 'antd';
import { dayFormatType, formatDay } from 'common/helpers/day';
import formatPrice from '~helpers/currency';
import Card from '../card';
import { bookingJourneyType } from 'common/constants/booking';
import { startCase } from 'lodash';

export default function BookingInfo({
  t,
  bookingJourney,
  showExtra = false,
  bookingInfo = {},
  setVisibleModal = () => {},
}) {
  const bookingInfoFields = [
    {
      label: 'Actual Move-in Date',
      value: bookingInfo?.moveInDate
        ? formatDay(dayFormatType.UKFORMAT, bookingInfo.moveInDate)
        : '-',
    },
    {
      label: 'Actual Move-out Date',
      value: bookingInfo?.moveOutDate
        ? formatDay(dayFormatType.UKFORMAT, bookingInfo.moveOutDate)
        : '-',
    },
    {
      label: 'Total Rent',
      value: bookingInfo?.totalRental
        ? formatPrice(bookingInfo.totalRental, bookingInfo.currency)
        : '-',
    },
    {
      label: 'Booking Status',
      value: bookingInfo?.stage ? startCase(bookingInfo.stage.toLowerCase()) : '-',
    },
  ];

  const createDateField = {
    label: 'Create Date',
    value: bookingInfo?.createdAt ? formatDay(dayFormatType.UKWITHHMS, bookingInfo.createdAt) : '-',
  };

  const completeDateField = {
    label: 'Complete Date',
    value: bookingInfo?.completedAt
      ? formatDay(dayFormatType.UKWITHHMS, bookingInfo.completedAt)
      : '-',
  };

  let infoFields = bookingInfoFields;
  const CREATE_DATE_INDEX = 2;

  if (bookingJourney === bookingJourneyType.SEMI_AUTOMATIC) {
    infoFields = [
      ...bookingInfoFields.slice(0, CREATE_DATE_INDEX),
      createDateField,
      completeDateField,
      ...bookingInfoFields.slice(CREATE_DATE_INDEX),
    ];
  } else if (bookingJourney === bookingJourneyType.LEAD_GENERATION) {
    infoFields = [
      ...bookingInfoFields.slice(0, CREATE_DATE_INDEX),
      createDateField,
      ...bookingInfoFields.slice(CREATE_DATE_INDEX),
    ];
  }

  return (
    <Card
      title={t('landlord.booking.reconciliation.details.booking_info.title')}
      dataSet={infoFields}
      extra={
        showExtra && (
          <Icon onClick={() => setVisibleModal(true)} type="edit" style={{ color: '#38b2a6' }} />
        )
      }
    />
  );
}
